import * as React from "react";
const SvgAstronaut = props => <svg width={1024} height={1024} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" {...props}><g transform="translate(105,-16)"><path d="m11.626 955.79h774.02m-430.89-441.5 39.903 23.363c20.165 3.9522 44.726 26.437 50.688 51.492l82.525 89.32c-43.455 38.44-77.158 47.543-124.79 21.03l-1.0347 250.6-320.11 0.95135-1.3042-96.94c-32.195 0-68.064-31.233-68.13-66.236l-0.28457-150.17c-0.11398-60.146 48.042-99.901 72.447-100.86l35.126-22.67z" style={{
      fill: "#fff",
      paintOrder: "markers fill stroke"
    }} /><path d="m119.93 774.21c8.5747 53.403-51.632 82.13-90.645 44.108" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 34,
      stroke: "#c5dce5"
    }} /><path d="m239.33 126.41c-124.59 0.73916-220.32 99.91-220.82 219.12-0.5 119.21 93.559 194.93 224.24 194.07 130.68-0.85966 208.15-87.032 208.87-194.64 0.72175-107.61-87.695-219.29-212.29-218.55z" style={{
      fill: "#c5dce5",
      paintOrder: "markers fill stroke"
    }} /><path d="m205.75 141.78c-124.59 0.73916-186.18 115.28-187.25 203.75s71.091 168.22 146.84 177.57c129.99 16.047 224.09-71.096 224.81-178.71 0.72175-107.61-59.807-203.35-184.4-202.61z" style={{
      fill: "#fff",
      paintOrder: "markers fill stroke"
    }} /><path d="m135.48 444.29c90.509 71.515 195.46 22.436 219.67-9.3832" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 27,
      stroke: "#c5dce5"
    }} /><path d="m199.5 896.22 0.0547 47.037" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeWidth: 28,
      stroke: "#c5dce5"
    }} /><rect x={520.82} y={321.63} width={289.56} height={203.18} style={{
      fill: "#c5dce5",
      paintOrder: "markers fill stroke"
    }} /><path d="m698.07 524.81c7.6463-1.1144 20.39-17.253 38.232-48.416l48.828-19.311v-135.45h-270v203.18z" style={{
      fill: "#fff",
      paintOrder: "markers fill stroke"
    }} /><rect x={546.09} y={389.35} width={60.826} height={67.727} style={{
      fill: "#3e5366",
      paintOrder: "markers fill stroke"
    }} /><rect x={606.92} y={321.63} width={60.826} height={67.727} style={{
      fill: "#3e5366",
      paintOrder: "markers fill stroke"
    }} /><rect x={606.92} y={457.08} width={60.826} height={67.727} style={{
      fill: "#3e5366",
      paintOrder: "markers fill stroke"
    }} /><rect x={667.74} y={389.35} width={59.119} height={67.727} style={{
      fill: "#3e5366",
      paintOrder: "markers fill stroke"
    }} /><rect x={726.86} y={321.63} width={58.265} height={67.727} style={{
      fill: "#3e5366",
      paintOrder: "markers fill stroke"
    }} /><rect x={726.86} y={457.08} width={58.265} height={67.727} style={{
      fill: "#3e5366",
      paintOrder: "markers fill stroke"
    }} /><rect x={515.13} y={321.63} width={30.962} height={67.727} style={{
      fill: "#3e5366",
      paintOrder: "markers fill stroke"
    }} /><rect x={515.13} y={457.08} width={30.962} height={67.727} style={{
      fill: "#3e5366",
      paintOrder: "markers fill stroke"
    }} /><rect x={785.13} y={389.35} width={25.255} height={67.727} style={{
      fill: "#3e5366",
      paintOrder: "markers fill stroke"
    }} /><path d="m506.82 951.09v-677.84" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 28,
      stroke: "#24394a"
    }} /><path d="m121.77 515.61c70.648 40.236 172.75 31.784 217.44 6.1628l35.286 23.806" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 28,
      stroke: "#c5dce5"
    }} /><path d="m79.652 550.33c77.478 84.059 274.34 66.217 319.03-4.6507" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 28,
      stroke: "#c5dce5"
    }} /><path d="m85.002 667.65 0.29049 70.298c14.001 0.3803 18.151 1.5815 26.421 2.4394" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 23,
      stroke: "#c5dce5"
    }} /><path d="m117.18 683.19-0.51439 55.005" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeWidth: 28,
      stroke: "#c5dce5"
    }} /><path d="m136.18 762.57c25.677 21.942 17.04 102.33-50.953 108.76" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeWidth: 28,
      stroke: "#c5dce5"
    }} /><path d="m29.684 814.69c-11.786-9.7225-15.162-19.063-17.172-26.813" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 28,
      stroke: "#c5dce5"
    }} /><path d="m239.33 126.41c-124.59 0.73916-220.32 99.91-220.82 219.12-0.5 119.21 93.559 194.93 224.24 194.07 130.68-0.85966 208.15-87.032 208.87-194.64 0.72175-107.61-87.695-219.29-212.29-218.55z" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 27,
      stroke: "#24394a"
    }} /><path d="m235.91 211.78c-88.168 1.8774-169.67 49.826-169.03 126.92 0.32728 39.529 22.524 73.313 56.937 96.427 173.6 116.6 391.68-90.211 219.34-195.66-29.796-18.231-67.747-28.53-107.25-27.689z" style={{
      fill: "#354a5e",
      paintOrder: "markers fill stroke"
    }} /><path d="m235.91 211.78c-88.168 1.8774-169.67 49.826-169.03 126.92 0.32727 39.529 22.524 73.313 56.937 96.427 197.5 27.816 255.86-80.196 215.72-196.86-29.796-18.231-64.125-27.322-103.62-26.481z" style={{
      fill: "#3e5366",
      paintOrder: "markers fill stroke"
    }} /><circle cx={147.98} cy={281.5} r={18.497} style={{
      fill: "#fff",
      paintOrder: "markers fill stroke"
    }} /><circle cx={114.97} cy={323.62} r={19.635} style={{
      fill: "#fff",
      paintOrder: "markers fill stroke"
    }} /><circle cx={125.68} cy={381.37} r={11.733} style={{
      fill: "#fff",
      paintOrder: "markers fill stroke"
    }} /><path d="m112.32 321.85 36.22-40.244" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 20,
      stroke: "#fff"
    }} /><path d="m182.53 675.29 114.39-0.28457" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 28,
      stroke: "#24394a"
    }} /><path d="m79.652 539.51c97.229 74.95 256.42 53.165 317.32-1.2359" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 28,
      stroke: "#24394a"
    }} /><path d="m109.1 671.22 0.56913 67.61c10.767 2.5395 33.758 22.97 33 52.886-0.8564 33.794-29.829 62.398-62.024 62.398-32.195 0-68.064-31.233-68.13-66.236l-0.28457-150.17c-0.11398-60.146 48.042-99.901 72.447-100.86l35.126-22.67" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeWidth: 28,
      stroke: "#24394a"
    }} /><path d="m354.76 514.3 39.903 23.363c20.165 3.9522 44.726 26.437 50.688 51.492" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeWidth: 28,
      stroke: "#24394a"
    }} /><path d="m89.006 494.81-0.22982 41.915" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeWidth: 28,
      stroke: "#24394a"
    }} /><path d="m384.96 495.95-0.22982 41.915" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeWidth: 28,
      stroke: "#24394a"
    }} /><path d="m82.461 861.9-0.51439 89.153" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeWidth: 28,
      stroke: "#24394a"
    }} /><path d="m381.73 939.64 0.22982-266.3c46.828 29.33 75.299 28.679 95.413 5.5314" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 35,
      stroke: "#c5dce5"
    }} /><path d="m402.05 950.1 1.0347-250.6c47.633 26.513 81.336 17.411 124.79-21.03" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 28,
      stroke: "#24394a"
    }} /><path d="m223.96 952.23-0.56913-66.589c-0.23519-27.517 30.527-22.423 30.449-3.1302l-0.28456 69.719" style={{
      fill: "#c5dce5",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 28,
      stroke: "#24394a"
    }} /><circle cx={506.57} cy={272.36} r={22.521} style={{
      fill: "#24394a",
      paintOrder: "markers fill stroke"
    }} /><path d="m11.626 955.79h774.02" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 28,
      stroke: "#24394a"
    }} /><path d="m517.61 555.01c-47.326 0.12587-54.922 28.477-55.221 61.16s8.0594 60.503 57.831 61.874c48.582 1.3382 59.651-31.093 60.775-58.016 1.1242-26.923-12.439-65.153-63.385-65.017z" style={{
      fill: "#c5dce5",
      paintOrder: "markers fill stroke"
    }} /><path d="m499.78 569.3c-25.038 3.0109-29.842 17.813-29.738 38.824s-0.93345 50.493 34.568 53.221c7.1097 0.54646 31.502-6.5444 31.318-30.65l-0.24686-32.46c-0.10857-14.277-14.622-31.494-35.901-28.935z" style={{
      fill: "#fff",
      paintOrder: "markers fill stroke"
    }} /><path d="m517.61 555.01c-47.326 0.12587-54.922 28.477-55.221 61.16s8.0594 60.503 57.831 61.874c48.582 1.3382 59.651-31.093 60.775-58.016 1.1242-26.923-12.439-65.153-63.385-65.017z" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 27,
      stroke: "#24394a"
    }} /><path d="m242.17 211.78c-83.452 0.19651-177.05 38.288-175.29 126.92s92.563 129 170.76 128.93c78.197-0.0613 163.47-38.009 166.28-123.63 2.8003-85.619-78.29-132.42-161.74-132.22z" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 27,
      stroke: "#24394a"
    }} /><path d="m506.54 307.97 283.71 1.1383c14.896 0.0598 33.321 16.976 33.294 31.872l-0.28456 160.5c-0.0271 15.302-16 33.579-31.302 33.579h-284.57" style={{
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 28,
      stroke: "#24394a"
    }} /></g></svg>;
export default SvgAstronaut;